<template>
  <div class="admin-header">
    <v-container fluid class="px-0">
      <v-row class="flex justify-space-between" no-gutters>
        <!-- Logo/Title Section -->

        <v-col cols="8" lg="6" align-self="center">
          <div class="d-flex align-start flex-column">
            <div class="d-flex align-center">
              <v-icon size="24" class="mr-2" color="primary">mdi-calendar-month-outline</v-icon>
              <span class="font-roboto font-weight-medium text-h5">{{
                $t('message.calendar_admin_plus.calendar')
                }}</span>
            </div>
            <div class="page-subtitle">
              {{ $t('message.calendar_admin_plus.calendar_header_subtitle') }}
            </div>
          </div>
        </v-col>

        <!-- Actions Section -->
        <v-col cols="4" lg="6" align-self="center">
          <v-row cols="12" sm="6" md="4" no-gutters class="d-flex align-center justify-end">
            <v-col cols="auto" class="d-flex">
              <v-menu elevation="0" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <PlusButton small intent="primary" :disabled="disabledActions">
                      <span class="font-roboto text-button d-inline">{{
                        $t(
                          'message.calendar_admin_plus.calendar_header_add_entry',
                        )
                      }}</span>
                    </PlusButton>
                  </span>
                </template>
                <v-list class="font-roboto text-body-1">
                  <v-list-item v-allowed="'edit_schedule'" @click="$emit('add-class')">
                    <v-list-item-title class="clickable">
                      <span>{{
                        $t(
                          'message.calendar_admin_plus.calendar_index_add_class',
                        )
                      }}</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="onCreateEvent">
                    <v-list-item-title class="clickable">
                      <span>{{
                        $t('message.calendar_admin_plus.create_event')
                      }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PlusButton from '@/components/plus/PlusButton.vue';

export default {
  name: 'ViewCalendarHeader',
  components: {
    PlusButton,
  },
  props: {
    disabledActions: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['add-class'],
  methods: {
    onCreateEvent() {
      this.navigateTo({
        name: 'manageacademyeventplus',
        params: { eventId: 'new' },
      });
    },
  },
};
</script>

<style scoped>
.admin-header {
  margin-bottom: 1rem;
  /* plusBorder is theme-aware via Vuetify customProperties: #E0E0E0 (light) / #424242 (dark). */
  border-bottom: 1px solid var(--v-plusBorder-base);
  padding-bottom: 1rem;
  height: auto;
  flex: 1;
}
</style>
